<!-- 个人信息 -->

<template>
  <div class="applyInitiation_personal">
    <div class="applyInitiation_personal_head">
      <span>个人信息</span>
      <span class="red">(必填)</span>
    </div>
    <div class="applyInitiation_personal_main">
      <ul class="applyInitiation_personal_list clearfix">
        <li class="clearfix">
          <div class="applyInitiation_personal_list_name left">姓名</div>
          <el-input v-model="personalFormData.gr_name" placeholder="请输入真实姓名" :disabled="isDisabled"></el-input>
        </li>
        <li class="clearfix">
          <div class="applyInitiation_personal_list_name left">性别</div>
          <el-select v-model="personalFormData.gr_sex" placeholder="请选择" :disabled="isDisabled">
            <el-option v-for="(item, index) in sexList" :key="index" :label="item" :value="item"> </el-option>
          </el-select>
        </li>
        <li class="clearfix">
          <div class="applyInitiation_personal_list_name left">身高</div>
          <el-select v-model="personalFormData.gr_height" placeholder="请选择" :disabled="isDisabled">
            <el-option v-for="(item, index) in heightList" :key="index" :label="item" :value="item"> </el-option>
          </el-select>
        </li>
        <li class="clearfix">
          <div class="applyInitiation_personal_list_name left">体重</div>
          <el-select v-model="personalFormData.gr_weight" placeholder="请选择" :disabled="isDisabled">
            <el-option v-for="(item, index) in weightList" :key="index" :label="item" :value="item"> </el-option>
          </el-select>
        </li>
        <li class="clearfix">
          <div class="applyInitiation_personal_list_name left">民族</div>
          <el-select v-model="personalFormData.gr_nation" placeholder="请选择" :disabled="isDisabled">
            <el-option v-for="(item, index) in nationList" :key="index" :label="item" :value="item"> </el-option>
          </el-select>
        </li>
        <li class="clearfix">
          <div class="applyInitiation_personal_list_name left">属相</div>
          <el-select v-model="personalFormData.gr_zodiac" placeholder="请选择" :disabled="isDisabled">
            <el-option v-for="(item, index) in zodiacList" :key="index" :label="item" :value="item"> </el-option>
          </el-select>
        </li>
        <li class="clearfix">
          <div class="applyInitiation_personal_list_name left">星座</div>
          <el-select v-model="personalFormData.gr_xz" placeholder="请选择" :disabled="isDisabled">
            <el-option v-for="(item, index) in xzList" :key="index" :label="item" :value="item"> </el-option>
          </el-select>
        </li>
        <li class="clearfix">
          <div class="applyInitiation_personal_list_name left">血型</div>
          <el-select v-model="personalFormData.gr_blood" placeholder="请选择" :disabled="isDisabled">
            <el-option v-for="(item, index) in bloodList" :key="index" :label="item" :value="item"> </el-option>
          </el-select>
        </li>
        <li class="clearfix">
          <div class="applyInitiation_personal_list_name left">信仰</div>
          <el-select v-model="personalFormData.gr_belief" placeholder="请选择" :disabled="isDisabled">
            <el-option v-for="(item, index) in beliefList" :key="index" :label="item" :value="item"> </el-option>
          </el-select>
        </li>
        <li class="clearfix">
          <div class="applyInitiation_personal_list_name left">籍贯</div>
          <el-cascader :disabled="isDisabled" v-model="nativeList" :options="cityList" @change="handleNativeChange"></el-cascader>
        </li>
        <li class="clearfix">
          <div class="applyInitiation_personal_list_name left">户口所在地</div>
          <el-cascader :disabled="isDisabled" v-model="placeList" :options="cityList" @change="handlePlaceChange"> </el-cascader>
        </li>
        <li class="clearfix">
          <div class="applyInitiation_personal_list_name left">出生日</div>
          <el-date-picker :disabled="isDisabled" v-model="personalFormData.gr_birth_date" type="date" value-format="yyyy-MM-dd" placeholder="出生日期">
          </el-date-picker>
        </li>

        <li class="clearfix">
          <div class="applyInitiation_personal_list_name left">婚姻状况</div>
          <el-select v-model="personalFormData.hyzk" placeholder="请选择" :disabled="isDisabled">
            <el-option v-for="(item, index) in maritalStatusList" :key="index" :label="item" :value="item"></el-option>
          </el-select>
        </li>
        <li class="clearfix">
          <div class="applyInitiation_personal_list_name left">原生家庭</div>
          <el-select v-model="personalFormData.is_ysjt" placeholder="请选择" :disabled="isDisabled">
            <el-option v-for="(item, index) in familyOfOriginList" :key="index" :label="item" :value="item"></el-option>
          </el-select>
        </li>
        <li class="clearfix">
          <div class="applyInitiation_personal_list_name left">是否有孩子</div>
          <el-select v-model="personalFormData.is_child" placeholder="请选择" :disabled="isDisabled" @change="handleHaveChildrenChange">
            <el-option v-for="(item, index) in haveChildrenList" :key="index" :label="item" :value="item"></el-option>
          </el-select>
        </li>
        <template v-if="personalFormData.is_child === '是'">
          <li class="clearfix">
            <div class="applyInitiation_personal_list_name left">孩子数量</div>
            <el-select v-model="personalFormData.child_num" placeholder="请选择" :disabled="isDisabled">
              <el-option v-for="(item, index) in childrenNumList" :key="index" :label="item" :value="item"></el-option>
            </el-select>
          </li>
          <li class="clearfix">
            <div class="applyInitiation_personal_list_name left">孩子情况</div>
            <el-select v-model="personalFormData.child_qk" placeholder="请选择" :disabled="isDisabled">
              <el-option v-for="(item, index) in childBelongList" :key="index" :label="item" :value="item"></el-option>
            </el-select>
          </li>
          <li class="clearfix">
            <div class="applyInitiation_personal_list_name left">抚养费</div>
            <el-select v-model="personalFormData.child_fyf" placeholder="请选择" :disabled="isDisabled">
              <el-option v-for="(item, index) in maintenanceList" :key="index" :label="item" :value="item"></el-option>
            </el-select>
          </li>
        </template>
        <li class="clearfix">
          <div class="applyInitiation_personal_list_name left">健康情况</div>
          <el-select v-model="personalFormData.jkqk" placeholder="请选择" :disabled="isDisabled">
            <el-option v-for="(item, index) in healthList" :key="index" :label="item" :value="item"></el-option>
          </el-select>
        </li>
        <li class="clearfix">
          <div class="applyInitiation_personal_list_name left">是否抽烟</div>
          <el-select v-model="personalFormData.re_smoke" placeholder="请选择" :disabled="isDisabled">
            <el-option v-for="(item, index) in smokingList" :key="index" :label="item" :value="item"></el-option>
          </el-select>
        </li>
        <li class="clearfix">
          <div class="applyInitiation_personal_list_name left">是否喝酒</div>
          <el-select v-model="personalFormData.re_drink" placeholder="请选择" :disabled="isDisabled">
            <el-option v-for="(item, index) in drinkList" :key="index" :label="item" :value="item"></el-option>
          </el-select>
        </li>
        <li class="clearfix">
          <div class="applyInitiation_personal_list_name left">是否想要孩子</div>
          <el-select v-model="personalFormData.re_want_child" placeholder="请选择" :disabled="isDisabled">
            <el-option v-for="(item, index) in wantList" :key="index" :label="item" :value="item"></el-option>
          </el-select>
        </li>
        <li class="clearfix">
          <div class="applyInitiation_personal_list_name left">何时结婚</div>
          <el-select v-model="personalFormData.re_marry" placeholder="请选择" :disabled="isDisabled">
            <el-option v-for="(item, index) in marryDateList" :key="index" :label="item" :value="item"></el-option>
          </el-select>
        </li>
        <li class="clearfix">
          <div class="applyInitiation_personal_list_name left">感情经历</div>
          <el-select v-model="personalFormData.h_feel" placeholder="请选择" :disabled="isDisabled">
            <el-option v-for="(item, index) in feelList" :key="index" :label="item" :value="item"></el-option>
          </el-select>
        </li>
        <li class="clearfix">
          <div class="applyInitiation_personal_list_name left">自己的优势</div>
          <el-input v-model="personalFormData.h_advantage" placeholder="请输入" :disabled="isDisabled"></el-input>
        </li>
        <li class="clearfix">
          <div class="applyInitiation_personal_list_name left" style="width: 164px">需要对方包容的地方</div>
          <el-input v-model="personalFormData.h_tolerate" placeholder="请输入" :disabled="isDisabled"></el-input>
        </li>
      </ul>

      <div class="uploadImg_identity_ul clearfix">
        <div class="uploadImg_identity_ul_left">
          <div class="uploadImg_identity_ul_top">
            <input :disabled="isDisabled" type="file" @input="uploadDivorceImg" />
            <img :src="divorceImgUrl" alt="" v-if="divorceImgUrl" />
            <img src="../../../assets/image/apply/5.png" alt="" v-else />
          </div>
        </div>
      </div>

      <div class="copy" v-if="!isDisabled" @click="handleSubmitPersonage">保存并继续</div>
    </div>
  </div>
</template>

<script>
import $DB from '../../../util/debounce'
import { uploadFile } from '../../../util/upload'

export default {
  name: 'Personal',
  props: {
    // 用户信息
    userInfo: {
      type: Object,
      default: () => ({}),
    },
    // 地区列表
    cityList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      // 个人信息
      userBasicInfo: {
        basic_status: 0,
      },

      sexList: [], // 性别数组
      heightList: [], // 身高数组
      weightList: [], // 体重列表
      nationList: [], // 民族列表
      zodiacList: [], // 属相列表
      xzList: [], // 星座列表
      bloodList: [], // 血型列表
      beliefList: [], // 信仰列表
      maritalStatusList: [], // 婚姻状况列表
      familyOfOriginList: [], // 原生家庭列表
      haveChildrenList: [], // 是否有孩子列表
      childrenNumList: [], // 孩子数量列表
      childBelongList: [], // 孩子情况列表
      maintenanceList: [], // 抚养费列表
      healthList: [], // 健康情况列表
      feelList: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'], // 感情经历列表
      smokingList: [], // 抽烟列表
      drinkList: [], // 喝酒列表
      wantList: [], // 是否想要孩子列表
      marryDateList: [], // 何时结婚列表

      nativeList: [], // 选择的籍贯省市
      placeList: [], // 选择的户口所在地省市

      personalFormData: {
        gr_name: '', // 姓名
        gr_sex: '', // 性别
        gr_height: '', // 身高
        gr_weight: '', // 体重
        gr_nation: '', // 民族
        gr_zodiac: '', // 属相
        gr_xz: '', // 星座
        gr_blood: '', // 血型
        gr_belief: '', // 信仰
        province: '', // 籍贯省
        city: '', // 籍贯市
        long_province: '', // 户口所在地（原长期居住地）省
        long_city: '', // 户口所在地（原长期居住地）市
        gr_birth_date: '', // 出生日

        // 202406 新增
        hyzk: '', // 婚姻状况
        is_ysjt: '', // 是否是原生家庭
        is_child: '', // 是否有孩子
        child_num: '', // 孩子数量
        child_qk: '', // 孩子情况
        child_fyf: '', // 抚养费

        // 202407 新增
        jkqk: '', // 健康情况
        h_feel: '', // 感情经历
        h_advantage: '', // 自己的优势
        h_tolerate: '', // 需要对方包容的地方

        re_smoke: '', // 是否抽烟
        re_drink: '', // 是否喝酒
        re_want_child: '', // 是否想要孩子
        re_marry: '', // 何时结婚

        re_pic: '', // 离婚丧偶证明 id
      },
      divorceImgUrl: '', // 离婚丧偶证明 url
    }
  },
  computed: {
    isDisabled() {
      return this.userInfo.check_status === 2 || this.userInfo.check_status === 3
      // return this.userBasicInfo.basic_status != 0 && this.userBasicInfo.basic_status != 5 && this.userInfo.check_status != 4 && this.userInfo.check_status != 0
    },
  },
  created() {
    this.funLoadUserBasic()

    // 类型:1性别:2 民族;3身高;4体重:5属相;6星座:7血型;8信仰;9 籍贯;10户口所在地;11学历;12毕业院校【对应School表];13公司类型:14职业:15收入:16兄弟姐妹几人;17婚姻状况:18住房情况:19买车情况:20是否抽烟;21是否喝酒;22是否有孩子;23 有几个孩子:24 是否想要孩子;25 何时结婚;26年龄;27身高;28期待结婚时间;29所在地:30推荐指数;32 工作性质;33住房是否有贷款;34车辆是否有贷款;35父母亲情况;36父母亲工作情况;37父母亲是否有退休金;38是否原生家庭;39感情经历:40孩子情况:41抚养费;42 健康情况；43 存款情况；44 债务情况
    const obj = {
      1: 'sexList', // 性别
      3: 'heightList', // 身高
      4: 'weightList', // 体重
      2: 'nationList', // 民族
      5: 'zodiacList', // 属相
      6: 'xzList', // 星座
      7: 'bloodList', // 血型
      8: 'beliefList', // 信仰
      17: 'maritalStatusList', // 婚姻状况列表
      38: 'familyOfOriginList', // 原生家庭列表
      22: 'haveChildrenList', // 是否有孩子列表
      23: 'childrenNumList', // 孩子数量列表
      40: 'childBelongList', // 孩子情况列表
      41: 'maintenanceList', // 抚养费列表
      42: 'healthList', // 健康情况列表
      20: 'smokingList', // 抽烟列表
      21: 'drinkList', // 喝酒列表
      24: 'wantList', // 是否想要孩子列表
      25: 'marryDateList', // 何时结婚列表
    }
    for (const key in obj) {
      this.funLodeCateList(+key, obj[key])
    }
  },
  methods: {
    /** 获取个人信息 */
    funLoadUserBasic() {
      this.$axios.post('/api/member/getUserBasic').then((res) => {
        this.userBasicInfo.basic_status = res.data.data.basic_status
        if (res.data.code === 0) {
          this.userBasicInfo = res.data.data
          this.nativeList = res.data.data.city
          this.placeList = res.data.data.long_city
          for (const key in this.personalFormData) {
            this.personalFormData[key] = this.userBasicInfo[key]
          }
          this.divorceImgUrl = this.userBasicInfo.re_pics
        }
      })
    },
    /**
     * 获取下拉选择内容
     * @param {Number} type 类型
     * @param {String} propName data 中的字段名
     */
    funLodeCateList(type, propName) {
      this.$axios.post('/api/index/cateList', { type }).then((res) => {
        if (res.data.code === 0) {
          this[propName] = res.data.data[0].cate_name
        }
      })
    },

    // 籍贯改变
    handleNativeChange(event) {
      this.personalFormData.province = event[0]
      this.personalFormData.city = event[1]
    },
    // 户口所在地改变
    handlePlaceChange(event) {
      this.personalFormData.long_province = event[0]
      this.personalFormData.long_city = event[1]
    },
    // 是否有孩子改变
    handleHaveChildrenChange() {
      if (this.personalFormData.is_child === '否') {
        this.personalFormData.child_num = ''
        this.personalFormData.child_qk = ''
        this.personalFormData.child_fyf = ''
      }
    },

    // 上传离婚丧偶证明
    uploadDivorceImg: $DB(async function (event) {
      if (!event.target.files.length) return

      const fileInfo = event.target.files[0]
      const result = await uploadFile(fileInfo, this)
      this.personalFormData.re_pic = result.id
      this.divorceImgUrl = result.url
    }),

    // 保存并继续
    handleSubmitPersonage: $DB(function () {
      if (!this.personalFormData.gr_name.trim()) return this.$message.error('请输入真实姓名')
      if (!this.personalFormData.gr_sex) return this.$message.error('请选择性别')
      if (!this.personalFormData.gr_height) return this.$message.error('请选择身高')
      if (!this.personalFormData.gr_weight) return this.$message.error('请选择体重')
      if (!this.personalFormData.gr_nation) return this.$message.error('请选择民族')
      if (!this.personalFormData.gr_zodiac) return this.$message.error('请选择属相')
      if (!this.personalFormData.gr_xz) return this.$message.error('请选择星座')
      if (!this.personalFormData.gr_blood) return this.$message.error('请选择血型')
      if (!this.personalFormData.gr_belief) return this.$message.error('请选择信仰')
      if (!this.personalFormData.province) return this.$message.error('请选择籍贯')
      if (!this.personalFormData.long_province) return this.$message.error('请选择户口所在地')
      if (!this.personalFormData.gr_birth_date) return this.$message.error('请选择出生日期')
      if (!this.personalFormData.hyzk) return this.$message.error('请选择婚姻状况')
      if (!this.personalFormData.is_ysjt) return this.$message.error('请选择是否是原生家庭')
      if (!this.personalFormData.is_child) return this.$message.error('请选择是否有孩子')
      if (this.personalFormData.is_child === '是') {
        if (!this.personalFormData.child_num) return this.$message.error('请选择孩子数量')
        if (!this.personalFormData.child_qk) return this.$message.error('请选择孩子情况')
        if (!this.personalFormData.child_fyf) return this.$message.error('请选择抚养费')
      }
      if (!this.personalFormData.jkqk) return this.$message.error('请选择健康情况')
      if (!this.personalFormData.re_smoke) return this.$message.error('请选择是否抽烟')
      if (!this.personalFormData.re_drink) return this.$message.error('请选择是否喝酒')
      if (!this.personalFormData.re_want_child) return this.$message.error('请选择是否想要孩子')
      if (!this.personalFormData.re_marry) return this.$message.error('请选择何时结婚')
      if (!this.personalFormData.h_feel) return this.$message.error('请选择感情经历')
      if (!this.personalFormData.h_advantage.trim()) return this.$message.error('请输入自己的优势')
      if (!this.personalFormData.h_tolerate.trim()) return this.$message.error('请输入需要对方包容的地方')
      // if (!this.personalFormData.re_pic) return this.$message.error('请上传离婚丧偶证明')

      // console.log({ ...this.personalFormData })
      // return

      this.$axios.post('/api/member/userBasic', this.personalFormData).then((res) => {
        if (res.data.code === 0) {
          this.$message.success(res.data.msg)
        } else {
          this.$message.error(res.data.msg)
        }
      })
    }),
  },
}
</script>

<style lang="scss" src="../index.scss" scoped></style>
